export default __webpack_public_path__ + "static/media/dev-per.c2471ecd.png";